const RELOAD_FLAG = 'bidali:chunk-reload';

const CHUNK_MESSAGE_PATTERNS = [
  /Loading chunk [\w-]+ failed/i,
  /Failed to load chunk/i,
  /Loading CSS chunk/i,
  /ChunkLoadError/i,
];

function getSessionStorage() {
  try {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage;
  } catch {
    return null;
  }
}

/**
 * Detect webpack / Next.js chunk load failures (common after a deploy
 * when a stale client requests hashed assets that no longer exist).
 */
export function isChunkLoadError(error) {
  if (!error) return false;

  const name = error.name || error.errorClass || '';
  const message = error.message || error.errorMessage || String(error);
  const code = error.code;

  if (name === 'ChunkLoadError') return true;
  if (code === 'CSS_CHUNK_LOAD_FAILED') return true;

  return CHUNK_MESSAGE_PATTERNS.some((pattern) => pattern.test(message));
}

export function hasAttemptedChunkReload() {
  return getSessionStorage()?.getItem(RELOAD_FLAG) === '1';
}

/**
 * Attempt a one-time full page reload. Returns:
 * - `'reloading'` when a reload was started
 * - `'prompt'` when a reload was already attempted this session
 */
export function recoverFromChunkLoadError() {
  if (typeof window === 'undefined') return 'prompt';

  if (hasAttemptedChunkReload()) {
    return 'prompt';
  }

  try {
    getSessionStorage()?.setItem(RELOAD_FLAG, '1');
  } catch {
    // sessionStorage may be unavailable; still attempt reload
  }

  window.location.reload();
  return 'reloading';
}

export function clearChunkReloadFlag() {
  try {
    getSessionStorage()?.removeItem(RELOAD_FLAG);
  } catch {
    // ignore
  }
}
